<template>
  <div class="row">
    <div class="col-md-12">
      <h4 class="title">{{ $t("packages") }}</h4>
    </div>
    <div class="col-md-12 card">
         <div class="card-header">
        <p-button class="btn btn-primary pull-right" @click="handleCreateModal">
          <i class="fa fa-plus"></i> {{ $t('new_package') }}
        </p-button>
      </div>
      <div class="card-body">
            <div class="row">
          <div class="col-md-6">
            <el-select
              v-model="pagination.perPage"
              :placeholder="$t('per_page')"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-6">
            <div class="pull-right">
              <fg-input
                class="input-sm"
                :placeholder="$t('search')"
                v-model="searchQuery"
                addon-right-icon="nc-icon nc-zoom-split"
              ></fg-input>
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <el-table
            v-loading="loading"
            :element-loading-text="$t('loading_data') + '...'"
            class="table-striped"
            :data="packages"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
              sortable
            ></el-table-column>
            <el-table-column
              fixed="right"
              class-name="td-actions text-center"
              :label="$t('crops')"
            >
              <template slot-scope="props">
                <p-button
                  type="primary"
                  size="sm"
                  icon
                  @click="handleEditModal(props.$index, props.row)"
                >
                  <i class="fa fa-edit"></i>
                </p-button>
                 <p-button
                  type="danger"
                  size="sm"
                  icon
                  @click="handleDletePrompt(props.$index, props.row)"
                >
                  <i class="fa fa-times"></i>
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="card-footer">
        <paginate
          :pagination="pagination"
          :metadata="metaData"
          :allData="getPackages"
        ></paginate>
      </div>
    </div>
    <!-- Add Modal -->
    <modal :show.sync="packagesModalOpened" headerClasses="justify-content-center">
      <h4 slot="header" class="title title-up">{{ $t("new_package") }}</h4>
      <ValidationObserver ref="packagesForm">
        <form>
          <ValidationProvider
            name="name"
            rules="required"
            v-slot="{ errors }"
          >
            <fg-input
              :error="errors[0]"
              v-model="package.name"
              :placeholder="$t('name')"
              :label="$t('name')"
            ></fg-input>
          </ValidationProvider>
          <ValidationProvider
            name="quantity"
            rules="required"
            v-slot="{ errors }"
          >
            <fg-input
              :error="errors[0]"
               v-model="package.quantity"
              :placeholder="$t('quantity')"
              :label="$t('quantity')"
            ></fg-input>
          </ValidationProvider>
          <ValidationProvider
            name="cost"
            rules="required"
            v-slot="{ errors }"
          >
            <fg-input
              :error="errors[0]"
              v-model="package.cost"
              :placeholder="$t('cost')"
              :label="$t('cost')"
            ></fg-input>
          </ValidationProvider>
        </form>
      </ValidationObserver>
      <template slot="footer">
        <div class="left-side">
          <p-button type="danger" link @click="handleCloseModal">{{
            $t("cancel")
          }}</p-button>
        </div>
        <div class="divider"></div>
        <div class="right-side">
          <p-button type="primary" link @click="updateMode?updatePackage():createPackage()">{{
            $t("save")
          }}</p-button>
        </div>
      </template>
    </modal>
  </div>
</template>
<script>
import Resource from "@/util/Api/resource.js";
import Modal from "src/components/UIComponents/Modal.vue";
import Paginate from "../../../UIComponents/Paginate.vue";

const PackageResource = new Resource("packages");

export default {
  components: {
    Modal,
    Paginate
  },
  data() {
    return {
      packagesModalOpened:false,
      packages:[],
      package: {
        name: "",
        quantity: "",
        cost: ""
      },
      pagination: {
        perPage: 10,
        perPageOptions: [10, 20, 30, 60, 500, 1000],
        currentPage: 1,
        nextPage: "",
        prevPage: "",
        total: 0,
        from: "",
        to: "",
        page: ""
      },
      searchQuery: "",
      loading: false,
      tableColumns: [
        {
          prop: "id",
          label: this.$t("id"),
          minWidth: 30
        },
        {
          prop: "name",
          label: this.$t("name"),
          minWidth: 200
        },
          {
          prop: "quantity",
          label: this.$t("quantity"),
          minWidth: 200
        },
         {
          prop: "cost",
          label: this.$t("cost"),
          minWidth: 200
        }
      ],
      metaData: {
        meta: "",
        links: ""
      }
    };
  },
  computed:{
    updateMode(){
      return !!this.package.id;
    }
  },
  methods: {
    handleCreateModal(){
      this.package = {};
      this.packagesModalOpened = true;
    },
    handleEditModal(index, row) {
      this.package = {...row};
      this.packagesModalOpened = true;
    },

    handleCloseModal() {
      this.package = {}
      this.packagesModalOpened = false;
    },

    handleDletePrompt(index,row){
    this.$confirm(
        this.$t('confirm_delete') + ' ' + this.$t('package') + "?",
        this.$t('warning'),
        {
          confirmButtonText: this.$t('yes'),
          cancelButtonText: this.$t('cancel'),
          cancelButtonClass: "btn-danger",
          confirmButtonClass: "btn-primary",
          type: "warning"
        }
      )
        .then(() => {
          this.deletePackage(row.id)
        })
        .catch(() => {});

    },

    showAlertMessage(message, type) {
      this.$message.closeAll();
      this.$message({
        type: type,
        message: message
      });
    },


    getPackages() {
      PackageResource.list('')
        .then(res => {
          this.packages = res.data;
        })
        .catch(error => {
          console.log("error", error);
        });
    },

    createPackage() {
       PackageResource.store(this.package)
        .then(response => {
          this.handleCloseModal();
          this.showAlertMessage(this.$t("package_created"), "success");
          this.packages = [response.data,...this.packages]
        })
        .catch(error => {
          this.showAlertMessage(error.response.errors, "error");
          if (error.response.data.errors) {
            this.$refs.cropForm.setErrors(error.response.data.errors);
          }
        });
    },
    updatePackage() {
      PackageResource.updatePackage(this.package,this.package.id)
        .then(response => {
          this.handleCloseModal();
          this.showAlertMessage(this.$t("crop_assigned"), "success");
          this.packages = this.packages.map((p)=>{
            if(p.id===response.data.id){
              return response.data;
            }
            return p;
          });
        })
        .catch(error => {
          this.showAlertMessage(error.response.errors, "error");
          if (error.response.data.errors) {
            this.$refs.cropForm.setErrors(error.response.data.errors);
          }
        });
    },
     deletePackage(id) {
      PackageResource.destroy(id)
        .then(response => {
          this.handleCloseModal();
          this.showAlertMessage(this.$t("crop_assigned"), "success");
          this.packages = this.packages.filter((p)=>p.id!==id)
        })
        .catch(error => {
          this.showAlertMessage(error.response.errors, "error");
          if (error.response.data.errors) {
            this.$refs.cropForm.setErrors(error.response.data.errors);
          }
        });
    }
  },

  created() {
    this.getPackages();
  },
};
</script>
<style lang="scss">
.cropTable {
  height: 20px;
  overflow: auto;

  tbody {
    display: block;
    height: 30em;
    overflow: auto;

    tr {
      display: table;
      width: 100%;
      table-layout: fixed;
    }
  }
}

.cropBody {
  height: 40em;
  overflow: auto;
}
</style>
